var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrows1Brown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 6,
    viewBox: "0 0 48 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6363 4.67296L0 5.81271L5.24284 1.3677C6.04066 0.683848 7.1804 0.22795 8.32015 0.22795L17.3241 0V4.90091L7.6363 4.67296Z",
    fill: "#562501"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3184 4.90091V0L39.3223 0.22795C40.4621 0.22795 41.6018 0.683848 42.3997 1.3677L47.6425 5.81271L40.0062 4.67296L30.3184 4.90091Z",
    fill: "#562501"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrows1Brown);
export default __webpack_public_path__ + "static/media/brows-1-brown.011406f14d2f249ebfdc743a372e5f37.svg";
export { ForwardRef as ReactComponent };